<template>
    <div>

        <div class="row">
            <div class="col-sm-12">
                <checkbox class="my-2" v-model="prices[0].isTaxIncludedInPrice" @input="priceIncludeTaxesChanged" :disabled="disabled">
                    <span class="normal">
                        Price include taxes.
                    </span>
                </checkbox>
            </div>
        </div>


        <div class="row mb-4">
            <div class="col-sm-4">
                <v-select
                    v-if="types"
                    v-model="selectedPrincingType"serpa
                    :options="types"
                    label="description"
                    placeholder="- Select type -"
                    :disabled="disabled"
                    @input="updateType(selectedPrincingType)">
                </v-select>
            </div>

            <!-- ********************** -->
            <!-- PER ORDER -->
            <!-- ********************** -->
            <div class="col-sm-12 mt-3" v-if="selectedPrincingType && selectedPrincingType.id == 1">
                <div class="row">

                    <div class="col-sm-3">
                    <label class="full">Tax</label>
                        <!-- If the price is composit we will show the VAT's of the child items -->
                        <input type="text" disabled="disabled" :value="customPerPersonTaxes(prices[0].productGenderPriceComponents)" class="w-100" v-if="prices[0].productGenderPriceComponents && prices[0].productGenderPriceComponents.length > 0"></input>
                        <v-select
                            v-else-if="taxes"
                            v-model="prices[0].vatTypeHelper"
                            :options="taxes"
                            label="description"
                            placeholder="- Select tax -"
                            :disabled="disabled"
                            @input="updateTaxType(prices[0], prices[0].vatTypeHelper)">
                        </v-select>
                    </div>

                    <div class="" v-if="perOrderReferenceGenderPrice">
                        <label class="full">Price</label>
                        <div class="d-flex align-items-center">

                            <input type="text" disabled="disabled" :value="customPerPersonTotal(perOrderReferenceGenderPrice.productGenderPriceComponents)+' €'" class="" style="width: 90px;" v-if="perOrderReferenceGenderPrice.productGenderPriceComponents && perOrderReferenceGenderPrice.productGenderPriceComponents.length > 0"></input>
                            <div class="d-flex" v-else>
                                <input :disabled="disabled" class="glued-right" type="number" v-model="prices[0].value" style="width: 4rem;">
                                <div class="glued-left">€</div>
                            </div>

                            <i class="fas fa-calculator fs-large medium ml-3" :class="{'pointer':!disabled, 'notAllowed':disabled}" v-tooltip="'Edit'" @click="openEditPrice(perOrderReferenceGenderPrice)"></i>
                        </div>

                    </div>

                </div>

                <div class="row">
                    <!-- Gender prices -->
                     <div class="col-sm-12 mt-3">

                        <div class="pricesRowHolder">
                            <div class="mt-2 mb-3 pb-3 border-bottom-medium" v-for="pricePerPerson, index in prices" v-if="pricePerPerson.isExcludedFromBilling">

                                <!-- Index 0 is reserved/hidden because the 0 is the "ghost" gender price that has the price -->
                                <price-manager-row  :disabled="disabled" :pricePerPerson="pricePerPerson" @delete="deletePrincingType(index)" :pricePerOrder="true" :audienceTypes="genderPricesAvailableOptions" />

                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <div class="add d-flex align-items-center fs-small bold" :class="{'pointer':!disabled, 'notAllowed':disabled}" @click="addRow">
                                    <i class="ico-add fs-smallest add-circle color-1"></i> Add participant
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


            <!-- ********************** -->
            <!-- PER PERSON -->
            <!-- ********************** -->
            <div class="col-sm-12 mt-3" v-if="selectedPrincingType && selectedPrincingType.id == 2">

                <div class="pricesRowHolder">
                    <div class="mt-2 mb-3 pb-3 border-bottom-medium" v-for="pricePerPerson, index in prices">

                        <price-manager-row :pricePerPerson="pricePerPerson" :disabled="disabled" :showDelete="prices.length > 1" @delete="deletePrincingType(index)" :audienceTypes="genderPricesAvailableOptions" />

                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-sm-12">
                        <div class="add d-flex align-items-center fs-small bold" :class="{'pointer':!disabled, 'notAllowed':disabled}" @click="addRow">
                            <i class="ico-add fs-smallest add-circle color-1"></i> Add new price
                        </div>
                    </div>
                </div>

            </div>

        </div>


    </div>
</template>

<script>
import extendedVSelect from '@/extends/vue-select'
import {mapActions, mapGetters} from 'vuex'
import PriceManagerRow from './pricingManager/priceRow.vue'
export default {
    data: function() {
        return {
            selectedPrincingType: null,

        }
    },
    props: {
        value:{
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    created: function () {
        if(this.prices){
            for (let pricingRow of this.prices) {
                //if(pricingRow.genderPriceType == 2){
                    pricingRow.vatTypeHelper = this.taxes.filter((audienceType) => {
                        return audienceType.id == pricingRow.vatType;
                    })[0]

                    pricingRow.audienceTypeHelper = this.getAudienceTypeList.filter((audienceType) => {
                        return audienceType.id == pricingRow.audienceType;
                    })[0]
                //}
            }
        }
    },
    computed: {
        ...mapGetters([
            'getVatTypes',
            'getModal',
            'getAudienceTypeList'
        ]),
        activeGenderPrices: function () {
            return this.value.map(genderPrice => {
                if(genderPrice.audienceTypeHelper){
                    return genderPrice.audienceTypeHelper
                } else {
                    return null
                }
            })
        },
        genderPricesAvailableOptions: function () {
            let output = this.audienceTypes.filter(audienceItem => {
                return !this.activeGenderPrices.find(genderPrice => {
                    if(genderPrice){
                        return genderPrice.id == audienceItem.id
                    } else {
                        return false
                    }
                })
            })

            // if price is Per Order we will hide all audiences that have occupancy higher than 1
            if(this.selectedPrincingType.id == 1){
                return output.filter(audience => {return audience.occupancy <= 1})
            } else {
                // if is price Per Person we show all gender prices
                return output
            }

        },
        prices:{
            get() {
                return this.value
            },
            set(newVal) {
                this.$emit('input', newVal)
            }
        },
        taxes: function () {
            return this.getVatTypes
        },
        audienceTypes: function () {
            return this.getAudienceTypeList
        },
        perOrderReferenceGenderPrice: function () {
            let output = this.prices.find(price => price.isExcludedFromBilling == false)
            if(output !== undefined){
                return output
            } else {
                this.prices[0]
            }
        }
    },
    asyncComputed: {
        async types() {
            // TODO: ADD THIS TO STORE
            try {
                let response = await axios.get('/api/settings/GetComponentExtraPriceTypeList');

                if (response && response.status === 200 && response.data && response.data.length > 0) {

                    // set the pricing dropdow to "Per order" or "Per Person"
                    try {
                        if(this.prices.length == 0){
                            this.selectedPrincingType = response.data[0];
                        } else {
                            if(this.prices[0].genderPriceType == 1){
                                this.selectedPrincingType = response.data[0];
                            } else {
                                this.selectedPrincingType = response.data[1];
                            }
                        }

                    } catch (e) {

                    }

                    return response.data;
                }
            }
            catch (error) {
                this.$toasted.error(error);
            }
        },
    },
    methods: {
        ...mapActions([
            'openModal',
            'updateroductEditPriceData'
        ]),
        priceIncludeTaxesChanged: function (val) {
            this.value.map(i => i.isTaxIncludedInPrice = val)
        },
        changed: function () {
            console.log('changed', this.prices);
            // this.$emit('input', this.value)
        },
        customPerPersonTaxes: function(row) {
            let taxes = [];
            for (let service of row) {
                // if(taxes.indexOf(service.component.vatType+'%') == -1){
                //     taxes.push(service.component.vatType+'%')
                // }
                if(service.component.selectedPrice && taxes.indexOf(service.component.selectedPrice.vatType+'%') == -1){
                    taxes.push(service.component.selectedPrice.vatType+'%')
                }
            }
            return taxes.join(', ')
        },
        updateType: function(selectedType){
            console.log('updateType', selectedType);
            let previousIncludeTax = this.prices[0].isTaxIncludedInPrice

            if(selectedType.id == 1){
                if(this.prices[0].genderPriceType == 2){
                    this.prices = [
                        {
                            genderPriceType: 1,
                            isExcludedFromBilling: false,
                            vatType: 0,
                            value: 0,
                            isTaxIncludedInPrice: previousIncludeTax,
                            currency: "€",
                            productGenderPriceComponents: [],
                        }
                    ]
                }
            } else {

                if(this.prices[0].genderPriceType == 1){
                    this.prices = [
                        {
                            genderPriceType: 2,
                            audienceType: this.audienceTypes[0].id,
                            audienceTypeHelper: this.audienceTypes[0],
                            value: 0,
                            isTaxIncludedInPrice: previousIncludeTax,
                            currency: '€',
                            vatType: this.taxes[0].id,
                            vatTypeHelper: this.taxes[0],
                            productGenderPriceComponents: [],
                        }
                    ]
                }
            }

            this.changed()

        },
        updateTaxType: function(row, selectedVatType){
            if(!selectedVatType){
                selectedVatType = this.taxes[0]
            }
            row.vatType = selectedVatType.id;
        },
        addRow: function() {
            if(this.disabled){
                return false
            }

            let defaultRow = {
                genderPriceType: this.selectedPrincingType.id,
                audienceType: this.genderPricesAvailableOptions[0].id,
                audienceTypeHelper: this.genderPricesAvailableOptions[0],
                isExcludedFromBilling: this.selectedPrincingType.id == 1? true : null,
                value: 0,
                currency: '€',
                vatType: this.taxes[0].id,
                vatTypeHelper: this.taxes[0],
                productGenderPriceComponents: []
            }


            this.prices.push(defaultRow)
            this.$forceUpdate();
        },
        deletePrincingType: function(index) {
            this.prices.splice(index, 1)
        },
        openEditPrice: function(priceRow) {
            if(this.disabled){
                return false
            }

            priceRow.id = null
            // priceRow.value = null
            this.updateroductEditPriceData(priceRow)

            // if we open the "Edit Price" modal and we are already on a modal, then we need to seed a callback to re-open the previous modal
            if(this.getModal.show === false){
                this.openModal('ProductEditPrice');
            } else {
                let currentModal = this.getModal.template
                this.openModal({
                    name: 'ProductEditPrice',
                    callback: () => {
                        console.log('EDIT PRICE CALLBACK', currentModal);
                        this.openModal(currentModal)
                    }
                });
            }
        },
        customPerPersonTotal: function(row) {
            let total = 0;
            for (let service of row) {
                // total += service.component.priceTotal
                if(service.component.selectedPrice){
                    total += service.component.selectedPrice.grossprice
                }
            }
            return (total).toFixed(2).replace(".", ",");
        },
    },
    components: {
        vSelect: extendedVSelect,
        PriceManagerRow
    }
}
</script>

<style lang="scss" scoped="">
.pricesRowHolder{

}
</style>



// WEBPACK FOOTER //
// PricingManager.vue?418f646c